import { Button, Form, Input, Checkbox, message, Select } from "antd";
import React, { useEffect, useState } from "react";
import { CloseButton, Modal } from "react-bootstrap";
import { useComponentStore } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";

function ComponentEditModal({
  modalShow,
  setModalShow,
  componentId,
  searchText,
}) {
  const {
    segData,
    contData,
    oneComponentData,
    segmentLoading,
    contentLoading,
    oneComponentLoading,
    postEditLoading,
    fetchComponentData,
    fetchAllSegment,
    fetchAllContent,
    fetchComponentDetail,
    postEditComponent,
  } = useComponentStore();
  const [contentData, setContentData] = useState([]);
  const [segmentData, setSegmentData] = useState([]);
  const [searchSegmentData, setSearchSegmentData] = useState([]);
  const [searchContentData, SetSearchContentData] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [order, setOrder] = useState("");
  const [selectedContent, setSelectedContent] = useState([]);
  const [selectedSeg, setSelectedSeg] = useState([]);
  const [dropDownoptions, setDropDownOptions] = useState([]);
  const { Option } = Select;
  const [form] = Form.useForm();
  const { setToaster } = useToast();

  useEffect(() => {
    fetchAllSegment();
    fetchAllContent();
    fetchComponentDetail(componentId);
  }, [componentId]);

  useEffect(() => {
    let componentData = contData?.data?.map((row) => {
      return {
        label: row?.displayName,
        value: row?._id,
      };
    });
    SetSearchContentData(componentData);
    setContentData(componentData);
    const res = segData?.data?.filter((row) => row.is_active === true);
    let segmentData = res?.map((row) => {
      return {
        label: row.display_name,
        value: row.id,
      };
    });
    setSearchSegmentData(segmentData);
    setSegmentData(segmentData);
    getOrder();
  }, [segData, contData]);

  useEffect(() => {
    const oneCompData = oneComponentData?.data;
    const content = (oneCompData?.component_content || [])?.map(
      (contentData) => contentData._id
    );

    setSelectedContent(content);
    const segment = (oneCompData?.component_segment || [])?.map(
      (compData) => compData?.segment_id
    );

    setSelectedSeg(segment);
    setOrder(oneCompData?.order);
    setIsActive(oneCompData?.type === "custom" ? true : false);
    form.setFieldsValue({
      contentName: oneCompData?.display_name,
      displayTitle: oneCompData?.display_title,
    });
  }, [oneComponentData]);

  const onSearchSegment = (val) => {
    const searchData = searchSegmentData?.filter((row) =>
      row.label?.toLowerCase().includes(val.toLowerCase().trim())
    );
    setSegmentData(searchData);
    if (val.trim() === "") {
      setSegmentData(searchSegmentData);
    }
  };

  const onSearchContent = (val) => {
    const searchData = searchContentData?.filter((row) =>
      row.label?.toLowerCase().includes(val.toLowerCase().trim())
    );
    setContentData(searchData);
    if (val.trim() === "") {
      setContentData(searchContentData);
    }
  };

  const handleSubmit = (data) => {
    const { contentName, displayTitle } = data;

    const _data = {
      displayName: contentName,
      order: order,
      displayTitle,
      segmentIds: selectedSeg,
      contentIds: selectedContent,
      type: isActive ? "custom" : "system",
    };
    postEditComponent(
      componentId,
      _data,
      setToaster,
      fetchComponentData,
      searchText,
      setModalShow
    );
  };

  const getOrder = async () => {
    try {
      const ordersList = Array.from({ length: 30 }, (_, orderData) => orderData + 1);
      const mappedValues = ordersList?.map((val) => {
        return {
          label: `order ${val}`,
          value: val,
        };
      });
      setDropDownOptions(mappedValues);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div>
      <>
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
              Component
            </Modal.Title>
            <CloseButton
              className="btn btn-circle btn-sm transition-base p-0"
              onClick={() => setModalShow(false)}
            />
          </Modal.Header>
          <Modal.Body>
            <Form form={form} onFinish={handleSubmit}>
              <Form.Item
                label="Component Name"
                name="contentName"
                rules={[
                  { required: true, message: "Please enter content name" },
                ]}
              >
                <Input placeholder="" />
              </Form.Item>

              <Form.Item
                label="Display Title"
                name="displayTitle"
                rules={[
                  {
                    required: true,
                    message: "Please enter display name",
                  },
                ]}
                style={{ width: "90%", marginLeft: "10%" }}
              >
                <Input placeholder="" />
              </Form.Item>
              <Form.Item
                label="Select Segments"
                // name="segment"
                rules={[{ required: true, message: "Select segment" }]}
                style={{ width: "94%", marginLeft: "6%" }}
              >
                <Select
                  mode="multiple"
                  placeholder="select segments"
                  options={segmentData}
                  value={selectedSeg}
                  onChange={(value) => {
                    setSegmentData(searchSegmentData);
                    setSelectedSeg(value);
                  }}
                  onSearch={onSearchSegment}
                  filterOption={false}
                />
              </Form.Item>
              <Form.Item
                label="Select Contents"
                // name="content"
                rules={[{ required: true, message: "Select Content" }]}
                style={{ width: "92%", marginLeft: "8%" }}
              >
                <Select
                  mode="multiple"
                  placeholder="select contents"
                  options={contentData}
                  value={selectedContent}
                  onChange={(value) => {
                    setContentData(searchContentData);
                    setSelectedContent(value);
                  }}
                  onSearch={onSearchContent}
                  filterOption={false}
                />
              </Form.Item>
              <Form.Item
                label="Select Order"
                name="order"
                rules={[{ required: true, message: "Select content" }]}
                style={{ width: "89%", marginLeft: "11%" }}
              >
                <Select
                  allowClear
                  placeholder="Select Order"
                  value={order}
                  onChange={(role) => {
                    setOrder(role);
                  }}
                >
                  {dropDownoptions &&
                    dropDownoptions.map((item) => (
                      <Option value={item?.value} key={item.value}>
                        {item.label}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
              <Form.Item
                label="Custom Component"
                name="status"
                style={{ marginLeft: "2%" }}
              >
                <Checkbox
                  checked={isActive}
                  onChange={({ target }) => setIsActive(target.checked)}
                >
                  {isActive ? "Active" : "Inactive"}
                </Checkbox>
              </Form.Item>
              <br />
              <Form.Item className="float-end">
                <Button htmlType="submit" type="primary">
                  Save Component
                </Button>
              </Form.Item>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={() => setModalShow(false)}>Close</Button>
          </Modal.Footer>
        </Modal>
      </>
    </div>
  );
}

export default ComponentEditModal;
